import { z } from 'zod'
import { ActorNameSchema } from '@/shared/lib'

// Задача сделки. Персонального исполнителя нет: задача принадлежит стороне
// заказчика, и заказчик видит все задачи своих сделок. tags — employee-only
// (опциональны), overdue — derived.
export const TaskSchema = z.object({
  id: z.string(),
  project_id: z.string(),
  title: z.string(),
  due: z.string().optional(),
  done: z.boolean(),
  completed_by: ActorNameSchema.optional(),
  completed_at: z.string().optional(),
  created_at: z.string(),
  created_by: ActorNameSchema,
  // Блокирует перенос проекта на следующий этап (ставит только сотрудник).
  blocking: z.boolean().optional(),
  overdue: z.boolean().optional(),
  tags: z.array(z.string()).optional(),
})
export type Task = z.infer<typeof TaskSchema>

export const TaskProjectRefSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
})
export const TaskCompanyRefSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
})

// Строка глобального списка задач (/tasks): задача + контекст проекта/компании
// для deep-link + теги (заказчику приходят пустым массивом).
export const TaskListItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  due: z.string().optional(),
  done: z.boolean(),
  completed_at: z.string().optional(),
  blocking: z.boolean().optional(),
  overdue: z.boolean(),
  created_at: z.string(),
  project: TaskProjectRefSchema,
  company: TaskCompanyRefSchema,
  tags: z.array(z.string()),
})
export type TaskListItem = z.infer<typeof TaskListItemSchema>

// Полная задача (страница задачи): строка списка + авторство. Заказчику бэк
// опускает employee-only поля (tags/version) — на странице задачи в контуре
// проекта они опциональны.
export const TaskReadSchema = TaskListItemSchema.extend({
  tags: z.array(z.string()).optional(),
  created_by: ActorNameSchema.optional(),
  completed_by: ActorNameSchema.optional(),
})
export type TaskRead = z.infer<typeof TaskReadSchema>
